module.exports = __webpack_public_path__ + "img/cib.d131c9d2.png";